import React from 'react';
import classnames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import type { CSSProperties } from 'react';
import styles from './index.module.scss';

type ProductHeaderBannerProps = {
  productLogo?: string;
  productName?: string;
  className?: string;
  style?: CSSProperties;
};
const ProductHeaderBanner = React.forwardRef<HTMLHeadElement, ProductHeaderBannerProps>(
  ({ productLogo, productName, className, style }, ref) => {
    return (
      <header ref={ref} className={classnames(styles.header, className)} style={style}>
        <div className={styles.productHeaderContent}>
          <LazyLoadImage
            className={styles.logo}
            width="80"
            height="80"
            src={productLogo}
            placeholderSrc="//images.dtcj.com/cbndata/icon/loading.gif"
            wrapperClassName={styles.productLogoImgWrapper}
          />
          <h1 className={styles.name}>{productName}</h1>
        </div>
      </header>
    );
  }
);
export default ProductHeaderBanner;
